import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';
export function ResearchSection() {
  return <section className="py-20 bg-slate-900 text-white relative overflow-hidden" data-id="element-240">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-241" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-242">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-243">
          <div data-id="element-244">
            <div className="inline-flex items-center space-x-2 text-emerald-400 font-bold tracking-wider uppercase text-base mb-4" data-id="element-245">
              <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse" data-id="element-246" />
              <span data-id="element-247">Medical Breakthrough</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-248">
              While GPs Hand Out Pills... <br data-id="element-249" />
              <span className="text-blue-300" data-id="element-250">
                European Vascular Specialists Have Been Solving This For
                Decades.
              </span>
            </h2>

            {/* GP Doctors Image */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="mb-8 rounded-xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-251">
              <img src="https://cdn.magicpatterns.com/uploads/eCSpzXqTCP4AVXgxwvwZbz/3.png" alt="European vascular specialists at medical conference" className="w-full h-auto" data-id="element-252" />
            </motion.div>

            <p className="text-slate-300 text-xl mb-6 leading-relaxed" data-id="element-253">
              In 2022, the European Society for Vascular Surgery published
              clinical guidelines that shocked many doctors. They officially
              recommended plant-based venoactive drugs for treating pelvic
              venous disorders.
            </p>
            <p className="text-slate-300 text-lg mb-8" data-id="element-254">
              These botanicals do not shrink your prostate. They strengthen your
              veins, improve drainage, and reduce the pressure that has been
              crushing your bladder every night for years.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-sm" data-id="element-255">
            <a href="https://esvs.org/wp-content/uploads/2023/03/ESVS-2022-CVD-Guidelines.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 mb-6 border-b border-white/10 pb-4 hover:border-emerald-400/30 transition-colors cursor-pointer group" data-id="element-256">
              <FileText className="w-6 h-6 text-emerald-400 group-hover:scale-110 transition-transform" data-id="element-257" />
              <span className="font-bold text-lg tracking-wide text-slate-200 group-hover:text-emerald-400 transition-colors" data-id="element-258">
                FROM THE ESVS 2022 GUIDELINES:
              </span>
            </a>
            <blockquote className="text-xl md:text-2xl font-serif italic text-white leading-relaxed mb-6" data-id="element-259">
              "Venoactive drugs decrease capillary permeability, reduce release
              of inflammatory mediators, and improve venous tone... Ruscus
              extracts [Butcher's Broom] received a strong recommendation (Grade
              1A)..."
            </blockquote>
            <div className="text-lg text-slate-400" data-id="element-260">
              — European Society for Vascular Surgery
            </div>
          </motion.div>
        </div>

        <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-261">
          <p className="text-xl font-medium text-[#e6b500]" data-id="element-262">
            Middle Aged men? They were never told any of this existed. Until
            now.
          </p>
        </div>
      </div>
    </section>;
}